import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import Text from "components/typography/Text";

const ConvertLocation = ({
	city,
	cityId,
	region,
	regionId,
	country,
	// url,
}) => {
	const { t } = useTranslation(["countries", "regions"]);
	const locationArray = [
		{
			type: "city",
			isset: (city && city.length > 0) || cityId,
			name: city,
			value: cityId,
		},
		{
			type: "region",
			isset: (region && region.length > 0) || regionId,
			name: regionId ? t(`regions:region_${regionId}`) : region,
			value: regionId,
		},
		{
			type: "country",
			isset: Boolean(country),
			name: t(`countries:${country}`),
			value: country,
		},
	].filter(({ isset }) => isset);

	const content = useMemo(
		() => ({
			linkable: locationArray
				.filter(({ value }) => Boolean(value) === true)
				.map(({ name }) => name)
				.join(", "),
			unlinkable: locationArray
				.filter(({ value }) => Boolean(value) === false)
				.map(({ name }) => name)
				.join(", "),
			all: locationArray.map(({ name }) => name).join(", "),
		}),
		[locationArray, city, cityId, region, regionId, country]
	);

	return <Text>{content.all}</Text>;
};

export default ConvertLocation;
